module.exports = __webpack_public_path__ + "img/b.91470d8f.jpg";